const $ = require('jquery');

// Make it easier to use jQuery from the console
window.$ = $;

require('./components/forms.js');
require('./components/menu.js');
// require('./components/header.js');
require('./components/responsive-bg.js');
require('./components/featherlight.js');
require('./components/sticky-menu.js');
require('./components/accordion.js');
require('./components/sidebar.js');
require('responsive-iframe');
